// extracted by mini-css-extract-plugin
export default {"text":"text__BZkx4"};